import { render, staticRenderFns } from "./WriterContentItemStepTableCell.vue?vue&type=template&id=08f932f3&scoped=true&"
import script from "./WriterContentItemStepTableCell.vue?vue&type=script&lang=ts&"
export * from "./WriterContentItemStepTableCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f932f3",
  null
  
)

export default component.exports